<div class="ok-dialog-container">
    <div class="ok-dialog-title">{{ data.title }}</div>

    <ng-container *ngIf="data.multiDescriptions">
        <ng-container *ngFor="let description of data.multiDescriptions" >
            <div class="ok-dialog-description" [innerHTML]="description"></div>
        </ng-container>
    </ng-container>



    <div class="ok-dialog-description" *ngIf="data.description" [innerHTML]="data.description"></div>


    <div *ngIf="data.hint" class="ok-dialog-hint warning-hint">
        <mat-icon color="warn" class="hint-icon">{{data.warningIcon || 'info'}}</mat-icon>
        <span [innerHTML]="data.hint"></span>
    </div>


    <div class="ok-dialog-actions">
        <button  mat-stroked-button color="basic" (click)="onCancel()">
            {{ data.close_button_text || 'Cancel' }}
        </button>
        <button [class]="data.confirm_button_class" mat-flat-button color="primary" (click)="onConfirm()">
            {{ data.confirm_button_text || 'OK' }}
        </button>
    </div>
</div>
